import { render, staticRenderFns } from "./ClinicInfoModal.vue?vue&type=template&id=5c5eb3aa&scoped=true"
import script from "./ClinicInfoModal.vue?vue&type=script&lang=js"
export * from "./ClinicInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicInfoModal.vue?vue&type=style&index=0&id=5c5eb3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5eb3aa",
  null
  
)

export default component.exports